// extracted by mini-css-extract-plugin
export default {"content":"PageWithHeader_content__I3l48"};